<template>
  <div class="home"> 
    <div class="header">
      <div class="header-container">
        <img v-lazy='src1' class="img" @click="link('/')">
        <div class="phone">61806590</div>
      </div>
      <div class="tabs pc">
        <ul class="nav">
          <router-link to="/" tag="li" class="item">首页</router-link>
          <router-link to="/enterprise" tag="li" class="item">高新技术企业认定</router-link>
          <li class="link">
            <el-dropdown @command="handleCommand" ref='link'>
            <span class="el-dropdown-link">知识产权</span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="/intellectual">知识产权服务</el-dropdown-item>
              <el-dropdown-item command="/compliance">贯标</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          </li>
          <router-link to="/cognizance" tag="li" class="item">双软认定</router-link>
          <router-link to="/support" tag="li" class="item">资金扶持</router-link>
          <router-link to="/news" tag="li" class="item">新闻资讯</router-link>
          <router-link to="/about" tag="li" class="item">关于我们</router-link>
          <router-link to="/contact" tag="li" class="item">联系我们</router-link>
        </ul>
      </div>
      <div class="tabs mobile">
        <div class="nav">        
            <img v-lazy='src2' @click="link('/')">
          <div class="phone">61806590</div>
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              <i class="el-icon-s-unfold"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="/">首页</el-dropdown-item>
              <el-dropdown-item command="/enterprise" @click="link('/enterprise')">高新技术企业认定</el-dropdown-item>
              <!-- <el-dropdown-item >知识产权</el-dropdown-item> -->
              <el-dropdown-item command="/intellectual">知识产权服务</el-dropdown-item>
              <el-dropdown-item command="/compliance">知识产权贯标</el-dropdown-item>
              <el-dropdown-item command="/cognizance">双软认定</el-dropdown-item>
              <el-dropdown-item command="/support">资金扶持</el-dropdown-item>
              <el-dropdown-item command="/news">新闻资讯</el-dropdown-item>
              <el-dropdown-item command="/about">关于我们</el-dropdown-item>
              <el-dropdown-item command="/contact">联系我们</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Technology from "@/views/technology/index";
import { close } from "fs";
export default {
  name: "Header",
  components: {
    Technology
  },
  data() {
    return {
      src1:require('@/assets/images/logo.png'),
      src2:require('@/assets/images/logo.jpg')
    };
  },
  methods: {
    handleCommand(command) {
      this.$router.push({ path: command });
      // this.$refs.link.style.backgroundcolor="#f9a72a"
    },
    link(path){
      this.$router.push({path:path})
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.router-link-exact-active {
  background-color: #f9a72a;
  color: #fff;
}
li {
  list-style: none;
  &:hover{
    background-color: #f9a72a;
  color: #fff;
  }
}
.home{background-color: #fff;width: 100%;position: fixed;
  top:0;
  left: 50%;
  z-index: 5;
  transform: translateX(-50%);
  border-bottom:1px solid #eee;
  }
.header {
  width: 1000px;
  margin: 0 auto;
  .header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 30px 0;
    border-bottom: 1px solid #eee;
    .img {
      width: 60%;
      cursor: pointer;
    }
    .phone {
      font-size: 26px;
      font-weight: 600;
    }
  }
  .mobile {
    display: none;
  }
  .tabs {
    font-size: 16px;
    background-color: #fff;

    .nav {
      display: flex;
      .el-dropdown {
        color: #000;
        font-size: 16px;
        &:hover{color:#fff}
      }
      .el-dropdown-link {
        cursor: pointer;
        
      }
      .el-dropdown,
      .item {
        padding: 15px 20px;
        cursor: pointer;
      }
    }
  }
  .navbar {
    margin-bottom: 0px;
  }
}

@media screen and (max-width: 768px) {
  .home{border-bottom:none;}
  .header {
    width: 100%;
    .header-container {
      display: none;
      padding: 10px;
      .img {
        width: 50%;
      }
      .phone {
        font-size: 14px;
      }
    }

    .pc {
      display: none;
    }
    .mobile {
      display: block;
    }
    .tabs {
      font-size: 16px;
      background-color: #424c77;
      .nav {
        height: 80px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 10px;
        color: #fff;
          
          img {
            width: 42%;
            flex:4;
          }
        .phone {
          flex:4;
          font-size: 14px;
          margin-left: 16px
        }
        .el-dropdown {
          color: #fff;
          font-size: 26px;
          line-height: 50px;
          padding:0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue